<script>
export default {};
</script>

<template>
  <div v-if="false">PromotionalArea</div>
</template>

<style></style>
